import GlobalTable from '@/components/probaworkflows_base_components/GlobalTable/GlobalTable.vue';
import ProbaWorkflowsSidebar from '@/components/probaworkflows_base_components/ProbaWorklfowsSidebar/ProbaWorkflowsSidebar.vue';
import navbar from "@/components/probaworkflows_base_components/Navbar/NavBar.vue";
import alert_mixin from '@/utils/mixins/alert_mixin';
import formatting_mixins from '@/utils/mixins/formatting_mixins';
import {
  get_headers,
  CREATE_ACTION,
  GET_ALL_ACTIONS,
  UPDATE_ACTION,
  DELETE_ACTION
} from '@/utils/constants/constants.js';
import axios from 'axios';

export default {
  name: 'ActionManagement',
  mixins: [alert_mixin, formatting_mixins],
  components: {
    ProbaWorkflowsSidebar,
    navbar,
    GlobalTable,
  },
  data: () => ({
    headers: get_headers(),
    actions: [],

    // Create Action Modal Fields
    action_name: '',
    action_description: '',

    // Update Action Modal Fields
    update_action_id: null,
    update_action_name: '',
    update_action_description: '',

    // Delete Action
    action_to_delete: null,

    // Loading states
    loading: false
  }),

  mounted() {
    this.load_actions();
  },

  methods: {
    go_back_to_company_management() {
      this.$router.push('/company_management');
    },

    async load_actions() {
      this.loading = true;
      try {
        const response = await axios.get(GET_ALL_ACTIONS, { headers: this.headers });

        if (response.data.status === 'success') {
          this.actions = response.data.data.map(action => ({
            id: action.id,
            action_name: action.action_name,
            description: action.description,
            date_created: this.format_date(action.date_created) || this.format_date(new Date().toISOString().split('T')[0])
          }));
        } else {
          this.show_error('Failed to load actions: ' + (response.data.message || 'Unknown error'));
        }
      } catch (error) {
        this.show_error('Error loading actions: ' + error.message);
      } finally {
        this.loading = false;
      }
    },

    async save_action_created() {
      if (!this.action_name.trim()) {
        this.show_error('Please enter an action name');
        return;
      }

      if (!this.action_description.trim()) {
        this.show_error('Please enter an action description');
        return;
      }

      const payload = {
        action_name: this.action_name.trim(),
        description: this.action_description.trim()
      };

      try {
        const response = await axios.post(CREATE_ACTION, payload, { headers: this.headers });

        if (response.data.status === 'success') {
          this.show_success('Action created successfully');
          this.reset_create_modal();
          await this.load_actions(); // Reload the actions list
        } else {
          this.show_error('Failed to create action: ' + (response.data.message || 'Unknown error'));
        }
      } catch (error) {
        this.show_error('Error creating action: ' + error.message);
      }
    },

    async update_actions() {
      // Validate inputs
      if (!this.update_action_name.trim()) {
        this.show_error('Please enter an action name');
        return;
      }

      if (!this.update_action_description.trim()) {
        this.show_error('Please enter an action description');
        return;
      }

      if (!this.update_action_id) {
        this.show_error('No action selected for update');
        return;
      }

      const payload = {
        action_id: this.update_action_id,
        action_name: this.update_action_name.trim(),
        description: this.update_action_description.trim()
      };

      try {
        const response = await axios.post(UPDATE_ACTION, payload, { headers: this.headers });

        if (response.data.status === 'success') {
          this.show_success('Action updated successfully');
          this.reset_update_modal();
          await this.load_actions(); // Reload the actions list
        } else {
          this.show_error('Failed to update action: ' + (response.data.message || 'Unknown error'));
        }
      } catch (error) {
        this.show_error('Error updating action: ' + error.message);
      }
    },

    async delete_action() {
      if (!this.action_to_delete) {
        this.show_error('No action selected for deletion');
        return;
      }

      const payload = {
        action_id: this.action_to_delete
      };

      try {
        const response = await axios.post(DELETE_ACTION, payload, { headers: this.headers });

        if (response.data.status === 'success') {
          this.show_success(response.data.message || 'Action deleted successfully');
          this.action_to_delete = null;
          await this.load_actions();
        } else {
          this.show_error(response.data.message || 'Unknown error');
        }

      } catch (error) {
        const backend_message = error.response?.data?.message;

        if (backend_message) {
          this.show_error(backend_message);
        } else {
          this.show_error('Error deleting action: ' + error.message);
        }
      }
    },

    reset_create_modal() {
      this.action_name = '';
      this.action_description = '';
    },

    reset_update_modal() {
      this.update_action_id = null;
      this.update_action_name = '';
      this.update_action_description = '';
    },

    set_edit_action(action) {
      this.update_action_id = action.id;
      this.update_action_name = action.action_name;
      this.update_action_description = action.description;
    },

    set_delete_action(actionId) {
      this.action_to_delete = actionId;
    }
  }
}